import { type FunctionComponent } from 'react';
import { type CommonPromoFieldsFragment } from '../../../__generated__/graphql-client-types';
import { type Category } from '../../../types/search.types';
import { PromoBanner } from '../../promo-banner/promo-banner.component';
import { CategoryBrandLogo } from '../category-brand-logo/category-brand-logo.component';
import { CategoryBrowseList } from '../category-browse-list/category-browse-list.component';
import { CategoryTextTile } from '../category-tile/category-tile.component';

export type SidebarBrowseProps = {
	category: Category;
	categoryType: string;
	categoryBrandName: string | null;
	topSecondaryPromo?: CommonPromoFieldsFragment;
	bottomSecondaryPromo?: CommonPromoFieldsFragment;
};

export const SidebarBrowse: FunctionComponent<SidebarBrowseProps> = ({
	category,
	categoryType,
	categoryBrandName,
	topSecondaryPromo,
	bottomSecondaryPromo
}) => {
	return (
		<div className="dn db-l w-25 mr3">
			{/* Brand Logo (brand categories only)*/}
			{categoryBrandName && <CategoryBrandLogo image={category.categoryContentOverride.categoryBrand?.brandImage} />}
			{/* Secondary (Top) Promo Banner (Construct) */}
			{topSecondaryPromo && <PromoBanner {...topSecondaryPromo} />}
			{/* Subcategory List Nav */}
			<CategoryBrowseList
				title={`Browse ${category.name}`}
				items={category.subCategories}
				itemTransform={(categoryProps) => (
					<CategoryTextTile
						{...categoryProps}
						className="bl-l br-l bb-l ph3 pv2"
						key={categoryProps.id}
						tileClass="tl tc1-title"
					/>
				)}
			/>
			{/* Secondary (Bottom) Promo Banner (Construct) */}
			{bottomSecondaryPromo && <PromoBanner {...bottomSecondaryPromo} />}
			<div id={`dy-recs-${categoryType}-browse-page-vertical`} data-testid="dy-recs-placement-vertical" />
		</div>
	);
};
